<template>
  <div>
    <el-popover v-if="hasReservations" placement="bottom" trigger="click" popper-class="popup-resa-detail">
      <div slot="reference">
        <div style="cursor: pointer; margin: 0 3px;" class="popup-resa-detail-title" v-html="title"></div>
      </div>
      <div class="popup-resa-detail-content">
        <button @click="printClients" class="print-button">
          <div class="print-icon"></div>
        </button>
        <div class="popup-resa-detail-content-salle" v-for="roomData in getResasDetails" :key="roomData.room">
          <h3 :data-content="roomData.room">{{ roomData.room }}</h3>
          <div v-if="roomData.reservations.length > 0">
            <div v-for="resa in roomData.reservations" :key="resa.nbCouvert"
              style="display: flex; align-items: center; gap: 4px;">
              <p>{{ resa.count }} réservation{{ resa.count > 1 ? 's' : '' }} de {{ resa.nbCouvert }} </p>
              <div class="user-icon"></div>
            </div>
          </div>
          <div v-else>
            <p>Aucune réservation</p>
          </div>
        </div>
      </div>
    </el-popover>
    <div v-else slot="reference">
      <div style="margin: 0 3px;" class="popup-resa-detail-title" v-html="title"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import * as resaState from '../../store/types/resa-state';

export default {
  name: 'PopupResaDetails',
  props: {
    date: {
      type: Object,
      required: true
    },
    title: {
      type: String
    },
    service: {
      type: String
    }
  },
  methods: {
    printClients: function (e) {
      e.preventDefault()
      e.stopPropagation()
      var mywindow = window.open('', 'PRINT', 'height=600,width=800')

      mywindow.document.write(`<html><head><title>${document.title}</title>`)
      mywindow.document.write('<style type="text/css">body{font-family:Arial}.el-col{display:inline-block}.resaline-state{display:none;}.resaline-row:before{content:" - ";display:inline-block; margin-right:10px;}.resaline-tags{display:none;}</style>')
      mywindow.document.write('</head><body >')
      var img = mywindow.document.createElement('img')
      img.setAttribute('src', 'https://staging.resa.ninja/icons/apple-touch-icon-120x120.png')
      img.style.display = 'block'
      img.style.position = 'absolute'
      img.style.left = '0'
      img.width = '80'
      img.height = '80'
      mywindow.document.body.appendChild(img)

      mywindow.document.write(`<div style="text-align:center; font-size:23px;margin-bottom:15px;"><strong>${this.getAllInfos.restoName}</strong><br><strong>${this.getCurrentDateLinearUnShorted}</strong><br>Service du <strong>${document.getElementById('serviceToPrint').innerText}</strong></div>`)
      const printableContent = `
        <html>
          <head>
            <style>
              body { font-family: Arial, sans-serif; }
              table { width: 100%; border-collapse: collapse; margin: 20px 0; }
              th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
              th { background-color: #f4f4f4; }
              h2 { margin-top: 20px; }
            </style>
          </head>
          <body>
            ${this.getResasDetails
          .map(roomData => `
                <table>
                  <thead>
                     <tr>
                      <th colspan="2">Salle: ${roomData.room}</th>
                    </tr>
                    <tr>
                      <th>Nombre de réservations</th>
                      <th>Nombre de couverts</th>
                    </tr>
                  </thead>
                  <tbody>
                    ${roomData.reservations
              .map(resa => `
                        <tr>
                          <td>${resa.count} réservation${resa.count > 1 ? 's' : ''}</td>
                          <td>${resa.nbCouvert} couvert${resa.nbCouvert > 1 ? 's' : ''}</td>
                        </tr>
                      `).join('')}
                  </tbody>
                </table>
              `).join('')}
          </body>
        </html>
      `
      mywindow.document.write(printableContent)
      mywindow.document.write('</body></html>')

      mywindow.document.close()
      mywindow.focus()

      mywindow.onload = () => {
        mywindow.print()
        mywindow.close()
      }

      return true
    }
  },
  computed: {
    ...mapGetters({
      getCurrentResas: 'newReservations/getCurrentResas',
      getCurrentResasByDay: 'newReservations/getCurrentResasByDay',
      getAllDiscount: 'discount/getAllDiscount',
      getAllServices: 'newServices/getAllServices',
      getAllInfos: 'infos/getAllInfos',
      getCurrentDateLinearUnShorted: 'calendar/getCurrentDateLinearUnShorted'
    }),
    hasReservations() {
      return this.getResasDetails.some(roomData => roomData.reservations.length > 0)
    },
    getResasDetails() {
      const currentResas = this.getCurrentResas
      const resasByRoom = {}

      currentResas
        .filter(resa => resa.state !== resaState.NO_SHOW && resa.state !== resaState.CANCELLED)
        .forEach(resa => {
          const room = resa.room || 'Aucune salle'

          if (!resasByRoom[room]) {
            resasByRoom[room] = {}
          }

          const nbCouvert = resa.nbCouvert

          if (resasByRoom[room][nbCouvert]) {
            resasByRoom[room][nbCouvert] += 1
          } else {
            resasByRoom[room][nbCouvert] = 1
          }
        })

      const result = []
      for (const room in resasByRoom) {
        const counts = resasByRoom[room]
        const countsArray = Object.keys(counts).map(nbCouvert => {
          return {
            nbCouvert: Number(nbCouvert),
            count: counts[nbCouvert]
          }
        })

        countsArray.sort((a, b) => a.nbCouvert - b.nbCouvert)

        result.push({
          room,
          reservations: countsArray
        })
      }

      return result
    }
  }
}
</script>

<style lang="scss">
@use "../../styles/mixins";

.popup-resa-detail {
  scrollbar-color: var(--dark__line_color-light) transparent;
  max-height: 300px;
  overflow-y: auto;
}

.popup-resa-detail {
  display: inline-block;

  &-title {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: clamp(40px, 10vw, 80px);

    &-couvor {
      @include mixins.mobile-portrait {
        display: none;
      }
    }
  }

  &-occupation {
    margin: 0px 3px;

    &-text {
      display: inline-block;

      @include mixins.mobile-portrait {
        display: none;
      }
    }

    &-percentage {
      @include mixins.mobile-portrait {
        display: inline-block;
      }
    }
  }

  &-small {
    display: block;
  }
}

.popup-resa-detail-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;

  .user-icon {
    display: inline-block;
    height: 12px;
    width: 14px;
    background-image: url("../../assets/svg/asset-user.svg");
    background-repeat: no-repeat;
    background-size: contain;
  }

  .print-button {
    background-color: transparent;
    border: none;
    cursor: pointer;

    .print-icon {
      height: 18px;
      width: 18px;
      background-image: url("../../assets/svg/asset-print.svg");
      background-repeat: no-repeat;
      background-size: contain;
      float: right;
    }
  }

  &-salle {
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: flex-start;

    h3 {
      text-transform: capitalize;
      margin: 0;
      color: white;
      padding: 5px;
      border-radius: 5px;
      background-color: var(--dark__main_color-light);
    }

    h3[data-content="Aucune salle"] {
      background-color: var(--color_gold);
      color: var(--dark__main_color-dark);
    }

    p {
      margin: 6px 0;
      letter-spacing: 0.5px;
    }
  }
}
</style>
